module.exports = {
	"pathContext": {
		"path": "/shop/merino-super-chunky-scarf/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/shop-merino-super-chunky-scarf.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/shop-merino-super-chunky-scarf.json
// module chunks = 102527728302540